<ng-container *ngIf="!useAlternate; else staticBackup">
  <div class="animation-container">
    <h1 class="good-job-text">{{ message }}</h1>
    <canvas riv="reflection-complete" class="animation-canvas" [height]="canvasHeight" [width]="canvasWidth">
      <riv-player name="play" [play]="playAnimation" (load)="loaded()"></riv-player>
    </canvas>
  </div>
</ng-container>

<ng-template #staticBackup>
  <div class="fallback-animation">
    <div class="diamond one"></div>
    <div class="diamond two"></div>
    <div class="diamond three"></div>
    <div class="diamond four"></div>
    <h1 class="animation-message">{{ message }}</h1>
    <div class="diamond five"></div>
    <div class="diamond six"></div>
    <div class="diamond seven"></div>
    <div class="diamond eight"></div>
  </div>
</ng-template>
